import Preloader from '@/components/atoms/Preloader';
//import Content from '@/components/molecules/Blocks';
import CloseIcon from '@mui/icons-material/Close';
import { Divider, IconButton, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';

declare const wc_add_to_cart_params: { ajax_url: string };

interface Props {
    dialogId: any;
    // eslint-disable-next-line @typescript-eslint/ban-types
    onClose: () => void;
    open: boolean;
}

const PopupBox = ({ dialogId, onClose, open }: Props): JSX.Element => {
    const [loading, setLoading] = useState(true);
    const [content, setContent] = useState<any>(null);
    const fetchData = async () => {
        setLoading(true);
        const data: any = {
            action: 'fetch_dialog_content',
            slug: dialogId,
        };

        try {
            const url = wc_add_to_cart_params.ajax_url.replace(
                '%%endpoint%%',
                'fetch_dialog_content',
            );

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type':
                        'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams(data),
            });

            const result = await response.json();
           
            if (result.success) {
                setContent(result.data);
            }  
            setLoading(false);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
    
        setContent(null);
        setLoading(true);
        if (!dialogId) return;
        
       fetchData();
    }, [dialogId]);

    return (
        <Dialog
            onClose={onClose}
            open={open}
            maxWidth={'md'}
            scroll={'body'}
            sx={{
                '& .MuiPaper-root': {
                    borderRadius: 4,
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    //alignItems: 'center',
                    paddingY: { xs: 4, sm: 4 },
                    paddingX: { xs: 4, sm: 4 },
                }}
            >
                {loading ? (
                    <Box
                        sx={{
                            minHeight: 400,
                            minWidth: { xs: 250, sm: 400 },
                        }}
                    >
                        {' '}
                        <Preloader />
                    </Box>
                ) : (
                    <>
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            sx={{
                                marginBottom: 0.5,
                            }}
                        >
                            <Typography
                                variant={'h4'}
                                fontWeight={700}
                                //align={'left'}
                                // marginBottom={1}
                            >
                                {content && content.post_title}
                            </Typography>
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                sx={{
                                    marginTop: -1,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>

                        <Box marginBottom={2}>
                            <Divider />
                        </Box>
                        <Box>
                            {content && content.post_content
                                ? parse(content.post_content)
                                : ''}
                        </Box>
                    </>
                )}
            </Box>
        </Dialog>
    );
};

export default PopupBox;
